import { useReducer } from "react";
import { DemoData } from "src/services/demo/queries/NetTypes";
import { ConnectedEntity } from "src/types/apps";

export const initial: State = {
	step: 0,
	email: "",
	token: "",
	connectionToken: ""
};

export interface State {
	step: number;
	email: string;
	token: string;
	connectionToken: string;
	entity?: ConnectedEntity;
	demoData?: DemoData;
}

enum ActionType {
	setStep = "setStep",
	onSelectEntity = "onSelectEntity",
	onSendVerificationEmail = "onSendVerificationEmail",
	onSetSessionToken = "onSetSessionToken",
	onConnectAccount = "onConnectAccount",
	onDemoFinished = "onDemoFinished"
}

interface Action {
	type: string;
	val: number | ConnectedEntity | string | DemoData;
}

function reducer(state: State, action: Action): State {
	switch (action.type) {
		case ActionType.setStep:
			return { ...state, step: action.val as number };
		case ActionType.onSelectEntity:
			return { ...state, step: 3, entity: action.val as ConnectedEntity };
		case ActionType.onSendVerificationEmail:
			return { ...state, email: action.val as string };
		case ActionType.onSetSessionToken:
			return { ...state, token: action.val as string, step: 2 };
		case ActionType.onConnectAccount:
			return { ...state, connectionToken: action.val as string, step: 4 };
		case ActionType.onDemoFinished:
			return { ...state, demoData: action.val as DemoData, step: 5 };
		default:
			throw new Error();
	}
}

export default function useDemoActionsStore() {
	const [state, dispatch] = useReducer(reducer, initial);

	const actions = {
		setStep: (val: number) => dispatch({ type: ActionType.setStep, val }),
		onSelectEntity: (val: ConnectedEntity) => dispatch({ type: ActionType.onSelectEntity, val }),
		onSendVerificationEmail: (val: string) =>
			dispatch({ type: ActionType.onSendVerificationEmail, val }),
		onSetSessionToken: (val: string) => dispatch({ type: ActionType.onSetSessionToken, val }),
		onConnectAccount: (val: string) => dispatch({ type: ActionType.onConnectAccount, val }),
		onDemoFinished: (val: DemoData) => dispatch({ type: ActionType.onDemoFinished, val })
	};

	return [state, actions] as const;
}
